export default __webpack_public_path__ + "static/media/Icon17.b41097bb.svg";